import {useState} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Button, Icon, IconTool} from '@gisatcz/ptr-atoms';
import LayersControls from './LayersControls';

import './style.scss';

const MapWrapper = ({
	backgroundLayer,
	layers,
	mapKey,
	fullWidth,
	chartExpanded,
	children,
}) => {
	const [open, setOpen] = useState(false);

	const classes = classnames('insar-MapWrapper', {
		open,
		'full-width': fullWidth,
		'is-chartExpanded': chartExpanded,
	});

	return (
		<div className="ptr-map-wrapper">
			<div className="ptr-light insar-LayersButton">
				<IconTool icon="layers" floating onClick={() => setOpen(!open)} />
			</div>
			<div className={classes}>
				<div className="insar-MapWrapper-header" onClick={() => setOpen(!open)}>
					<div className="insar-MapWrapper-title">
						<Icon icon="layers" />
						<h3>Layers</h3>
					</div>
					<Button
						icon="times"
						invisible
						small
						circular
						onClick={() => setOpen(!open)}
					/>
				</div>
				<div className="insar-MapWrapper-content">
					<LayersControls
						mapKey={mapKey}
						backgroundLayer={backgroundLayer}
						layers={layers}
					/>
				</div>
			</div>
			{children}
		</div>
	);
};

MapWrapper.propTypes = {
	backgroundLayer: PropTypes.object,
	layers: PropTypes.array,
	mapKey: PropTypes.string,
	fullWidth: PropTypes.bool,
	chartExpanded: PropTypes.bool,
	children: PropTypes.node,
};

export default MapWrapper;
